import { inject, Injectable } from "@angular/core";

import { BaseDao } from "../../core/Dao/base.dao";

import { OfflineTransactionStorageService } from "../storage/offline-transaction-storage.service";
import { OfflineTransaction } from "../../models/offline-transaction.model";

@Injectable({ providedIn: "root" })
export class OfflineTransactionDao extends BaseDao<OfflineTransaction> {
  protected readonly storage = inject(OfflineTransactionStorageService);

  protected override getUniqueKey(item: OfflineTransaction): string {
    return item.id;
  }
}
